/*
 * Copyright Evollis 2021
 * All Rights Reserved.
 *
 * All information contained herein is, and remains the property of Evollis.
 * The intellectual and technical concepts contained herein are
 * proprietary to Evollis and are protected by trade secret and copyright law.
 * Dissemination of this information or reproduction of this material
 * is STRICTLY FORBIDDEN unless prior written permission is obtained
 * from Evollis.
 */
import { loc } from "../../../core/utils"
import { contractTypeEnum } from "../../ClientPage/constants/ClientPageConstants"
import Bloc from "./Bloc"
import Field from "./Field"
import React from "react"

export default function SituationBloc({ configuration, values, tunnelData }) {
  const { situation } = configuration

  return (
    <Bloc hide={!situation} name="My situation">
      <Field
        hide={!situation?.includes("workingSector")}
        name={"working Sector"}
        value={values.situation.workingSector?.label}
      />
      <Field
        hide={!situation?.includes("professionalUse")}
        name={"professional Use"}
        value={values.situation.professionalUse?.label}
      />
      <Field
        hide={!situation?.includes("lineOfBusiness")}
        name={"line Of Business"}
        value={values.situation.lineOfBusiness?.label}
      />
      <Field
        hide={!situation?.includes("countryOfActivity")}
        name={"country Of Activity"}
        value={values.situation.countryOfActivity?.label}
      />

      <Field
        hide={!situation?.includes("profession")}
        name={"Occupation"}
        value={
          !values.situation.employmentDate
            ? values.situation.profession?.label
            : values.situation.profession?.label + loc(" since ") + values.situation.employmentDate
        }
      />
      <Field
        hide={!situation?.includes("workingSituation")}
        name={"Contract type"}
        value={values.situation.workingSituation?.label}
      />
      <Field
        hide={
          (values.situation.workingSituation === contractTypeEnum && situation?.includes("endcontractDate")) ||
          values.situation.endContractDate === null
        }
        name={"endContractDate"}
        value={values.situation.endContractDate}
      />
      {values.identity.isSmallBusiness ? (
        <Field
          hide={!values?.identity?.isSmallBusiness}
          name={loc("VatBusinessCode")}
          value={values.situation.vatBusinessCode}
        />
      ) : (
        <Field
          hide={!situation?.includes("netMonthlyIncome")}
          name={"Your net monthly income"}
          value={values.situation.netMonthlyIncome}
        />
      )}
      <Field hide={!situation?.includes("companyName")} name={"Company name"} value={values.situation.companyName} />
      <Field
        hide={!situation?.includes("companyCity")}
        name={"Company city"}
        value={values.situation.companyCity?.label}
      />
      <Field
        hide={!situation?.includes("companyProvince")}
        name={"Company province"}
        value={values.situation.companyProvince}
      />
      <Field
        hide={!situation?.includes("yearBankSeniority")}
        name={"Bank Seniority"}
        value={values.situation.yearBankSeniority}
      />
      <Field
        hide={!situation?.includes("housingType")}
        name={"Housing"}
        value={values.situation.housingType?.label + (values.situation.residenceDate ? loc(" since ") + values.situation.residenceDate : "")}
      />
      <Field
        hide={!situation?.includes("maritalStatus")}
        name={"Family situation"}
        value={values.situation.maritalStatus?.label}
      />
      <Field
        hide={!values.situation.maidenName || !situation?.includes("maidenName")}
        name={"Maiden name"}
        value={values.situation.maidenName}
      />
      <Field
        hide={!situation?.includes("dependentChildrenNumber")}
        name={"Number of dependent children"}
        value={values.situation.dependentChildrenNumber}
      />
    </Bloc>
  )
}
